export const IteratorBlockDocumentationMarkdown = `
## What does this block do?

The Iterator Block processes each item in a provided list by executing a designated subflow.

## When to use it?

When you need to perform a specific action for every record in a list.

Examples:

- Outreach to each patient in a provided list
- Do chart scrubbing for one patient and suspect multiple HCCs
- Process a referral fax file and categorize each extracted order

## How to configure this block?

1. Provide the part of the block payload which contains the items. For example putting \`{{patientNames.data.records}}\` in the **List to iterate** field will get values from the \`patientNames\` block and specifically the \`records\` portion of the payload.

Example Input:

~~~json
{
  "records": [
    {
      "id": 1,
      "name": "Alice Smith",
      "age": 35
    },
    {
      "id": 2,
      "name": "Bob Johnson",
      "age": 42
    }
  ]
}
~~~

2. Next, specify the subflow to be run for each item in the list. This is done the same way as in the Subflow block.

    When configuring the subflow's inputs, references may use \`element\` to access the current element in the list. 
    For example, with the above data, \`element.name\` would yield the name within each record.
    Similarly, \`index\` refers to the position of the element within the list, starting with zero
    (so \`index\` is 0 for the first record, 1 for the next, and so on). 

## Advanced Settings

**Waiting in between iterations** could be helpful if your list creates a set of action that require some time to pass to be completed. Perhaps you want to rate limit of how fast API calls are made as to not overload a system.

Set **Time Interval** to a number of seconds/minutes/hours you'd like to pass between each iteration.

## How to test

- Prepare your data to ensure the input list is available.
- Activate the mock output mode to simulate processing without triggering the actual action.
- Run the block to check that each item is processed correctly and that the aggregated results meet your expectations.

## Best Practices

- **Validate Input Data**: Confirm that structured and contains all required fields.
- **Leverage Dynamic Data**: Use dynamic notation (e.g., \`{{…}}\`) to pass in upstream values, making your iterations flexible.
- **Optimize Delay Settings**: Adjust the iteration pause to balance performance with system constraints.
- **When iterating through a large list and running subflows**: Limit each run to 1,000 items. If the flow remains in Running and the Iterator Block stops progressing, split the input into smaller batches and run them separately.
- **Test and Iterate**: Use the mock mode extensively during development to fine-tune error handling and output formatting.
`;
